import React from 'react';

const ThreeDots = (props) => {
  return (
    <svg width="4" height="16" viewBox="0 0 4 16" fill="#757575" {...props}>
      <path d="M0.167139 1.6137C0.167139 2.50492 0.889616 3.22739 1.78084 3.22739C2.67205 3.22739 3.39453 2.50492 3.39453 1.6137C3.39453 0.722476 2.67206 -3.15804e-08 1.78084 -7.05369e-08C0.889616 -1.09493e-07 0.167139 0.722476 0.167139 1.6137Z" />
      <path d="M0.167139 8.00041C0.167139 8.89163 0.889616 9.61411 1.78084 9.61411C2.67205 9.61411 3.39453 8.89163 3.39453 8.00041C3.39453 7.1092 2.67206 6.38672 1.78084 6.38672C0.889616 6.38672 0.167139 7.10919 0.167139 8.00041Z" />
      <path d="M0.167139 14.3871C0.167139 15.2784 0.889616 16.0008 1.78084 16.0008C2.67205 16.0008 3.39453 15.2784 3.39453 14.3871C3.39453 13.4959 2.67206 12.7734 1.78084 12.7734C0.889616 12.7734 0.167139 13.4959 0.167139 14.3871Z" />
    </svg>
  );
};

export default ThreeDots;
